import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find-index.js";
import "regenerator-runtime/runtime.js";
import { defineComponent, computed, onMounted, ref } from "vue";
import { ModalStatus } from "@/constants/modal";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import { useI18n } from "vue-i18n";
import ModalModule from "@/store/modules/modal";
import BookingModule from "@/store/modules/booking";
import closeIcon from "@/assets/images/svg/close.svg";
import NotificationService from "@/services/notification.service";
import { LogLevel, LogService } from "@/services/logging";
import { handleErrorAndPrepareMessage } from "@/utils/helpers/common";
import POSConfigModule from "@/store/modules/pos-config";
import UserModule from "@/store/modules/user";
import AuthModule from "@/store/modules/auth";
import { getProductCategoryById } from "@/utils/helpers/product-category";
import { PCTypes } from "@/types/db/product-category";
import CustomersModule from "@/store/modules/customers";
import { BookingStep } from "@/constants/booking";
import { ISynchingReason } from "@/interfaces/store/IBooking";
import { cloneDeep } from "lodash";
import { pullAndStorePCs } from "@/utils/vue-helpers/product-category";
import { toLocalProductSlotBooking } from "@/utils/vue-helpers/booking";
import { getFullBookingById } from "@/api/gql/product-slot-boooking";
import { POSConfigErrors } from "@/constants/errors/pos-config";
import { getUserAccessToken, getSmtzAuth, getSmtzAuthFromStorage } from "@/utils/helpers/auth";
import { getLanguage } from "@/utils/helpers/lang"; // @ts-ignore

import { SmeetzCalendars } from "/node_modules/@smeetz/calendars/dist/calendars.js";
import "/node_modules/@smeetz/calendars/dist/style.css";
import AppModule from "@/store/modules/app";
import PSSModule from "@/store/modules/pss";
import { addPSSExtensions } from "@/utils/vue-helpers/orders";
export default defineComponent({
  name: "OccupancyCalendar",
  components: {
    SmeetzCalendars: SmeetzCalendars
  },
  setup: function setup() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _useI18n, t, closeIconStyle, closeIconContent, closeIconAlt, showCalendar, dialogVisible, getOccupancyTableKey, getUserToken, getGroupId, getUserId, getUserGraphqlToken, env, onCalendar;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              onCalendar = function _onCalendar(value, type) {
                this.selectOrderForEditing(value.occupancyBookingId);
                console.log(type, " - ", value.occupancyBookingId);
              };

              _useI18n = useI18n({}), t = _useI18n.t;
              closeIconStyle = "width: 30px; height: 30px; filter: contrast(170%) invert(100%); cursor: pointer;";
              closeIconContent = closeIcon;
              closeIconAlt = "Close";
              showCalendar = ref(false);
              onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return getSmtzAuth();

                      case 2:
                        showCalendar.value = true;

                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));
              dialogVisible = dialogVisibleForStatus(ModalStatus.OccupancyCalendar);
              getOccupancyTableKey = computed(function () {
                return UserModule.getUser.tableSearchKeys.occupancy;
              });
              getUserToken = computed(function () {
                return AuthModule.token || getUserAccessToken();
              });
              getGroupId = computed(function () {
                var groupId = String(POSConfigModule.groupId);
                return groupId;
              });
              getUserId = computed(function () {
                return String(UserModule.userId);
              });
              getUserGraphqlToken = computed(function () {
                return getSmtzAuthFromStorage();
              });
              env = process.env.VUE_APP_ENV;
              return _context2.abrupt("return", {
                t: t,
                dialogVisible: dialogVisible,
                onCalendar: onCalendar,
                getOccupancyTableKey: getOccupancyTableKey,
                getUserToken: getUserToken,
                getGroupId: getGroupId,
                getLanguage: getLanguage,
                getUserGraphqlToken: getUserGraphqlToken,
                getUserId: getUserId,
                showCalendar: showCalendar,
                env: env,
                closeIconStyle: closeIconStyle,
                closeIconContent: closeIconContent,
                closeIconAlt: closeIconAlt
              });

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    close: function close() {
      ModalModule.setStatus(ModalStatus.Hidden);
    },
    selectOrderForEditing: function selectOrderForEditing() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var id, openTeamsView, selectedOrderId, pulledBooking, categoryIds, missingPCs, convertedBooking, i, childPSC, originalCopy, bookingUUID, customer, country, email, phone, _id, company, address, allergies, language, firstName, lastName, title, zipCode, emailMarketingOrganiser, birthDate, city, pssExtensionsCopy, _iterator, _step, pss, pc, errorDetails;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                id = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : "123456";
                openTeamsView = false;
                selectedOrderId = id; // Show a spinner telling the user to wait till we pull the booking
                // TODO Hamza: now you're showing the spinner in BaseLayout.vue/el-container element and you dynamically override one element z-index,
                // what would be better is attaching the spinner here in Orders.vue with a customized text
                // Try again when you have time

                AppModule.updatedIsLoading(true);
                _context3.prev = 4;
                LogService.info("Going to pull the booking with id: ".concat(selectedOrderId, " from backend"));
                _context3.next = 8;
                return getFullBookingById(selectedOrderId);

              case 8:
                pulledBooking = _context3.sent;
                LogService.info("We pulled the attached booking from backend, id: ".concat(pulledBooking === null || pulledBooking === void 0 ? void 0 : pulledBooking.id), {
                  params: pulledBooking
                }); // If no pulled order then show general error to the user

                if (!pulledBooking) {
                  LogService.info("No booking with id: ".concat(selectedOrderId, " was pulled from backend"), undefined, LogLevel.Error);
                  NotificationService.showGeneralResponseError();
                } // Check if PSS is linked to PSC that is not linked to the selected Config ticketGroups


                categoryIds = _this.getPSCNotIncludedInConfig(pulledBooking); // categoryIds = [43924]; //Snack 1, just to test

                if (!categoryIds.length) {
                  _context3.next = 17;
                  break;
                }

                // pull these PSC from remote and store them in indexedDB
                LogService.info("Going to pull PCs with  attached ids for Edit Order since they do not exist in current config", {
                  params: categoryIds
                });
                _context3.next = 16;
                return pullAndStorePCs(categoryIds);

              case 16:
                missingPCs = _context3.sent;

              case 17:
                _context3.next = 19;
                return toLocalProductSlotBooking(pulledBooking);

              case 19:
                convertedBooking = _context3.sent;
                LogService.info("We converted pulled booking into IPSB format, result object attached", {
                  params: convertedBooking
                }); // Foreach seating PSS, if it is none-reccuring seating plan, then you need to pull its eventKey from childPSC.seatingParentResourceEventKey

                i = 0;

              case 22:
                if (!(i < convertedBooking.pssList.length)) {
                  _context3.next = 30;
                  break;
                }

                _context3.next = 25;
                return getProductCategoryById(convertedBooking.pssList[i].categoryId);

              case 25:
                childPSC = _context3.sent;

                if (childPSC) {
                  // Lets check if this is a childPSC of a reccurring parent
                  if (!childPSC.isParentReccuringSeating) {
                    // so this pss is not a recurring seating plan, lets override the eventKey value of this pss
                    convertedBooking.pssList[i].eventKey = childPSC.seatingParentResourceEventKey;
                  }
                }

              case 27:
                i++;
                _context3.next = 22;
                break;

              case 30:
                // End of eventKey changes
                // Lets store an original copy of the booking in synchedBookings, we need to differentiate a synchedBooking that is coming from EditOrder not from promocodeLogic
                originalCopy = cloneDeep(convertedBooking);
                BookingModule.addSynchedPendingBooking({
                  booking: originalCopy,
                  reason: ISynchingReason.Edit_Order
                }); // Lets store it in bookingModule (bookings, bookingList, bookingsSteps) and consider this booking as the selected booking

                bookingUUID = convertedBooking.uuid;
                BookingModule.addBooking(convertedBooking); // If the pulled booking is of type Acompte, then we show the user the payment step (he can always go back)
                // If the pulled booking is a normal booking, then we put the user in order step

                if (openTeamsView) {
                  BookingModule.setBookingStep(_defineProperty({}, bookingUUID, BookingStep.Teams));
                } else if (BookingModule.isAcompteBooking) {
                  BookingModule.setBookingStep(_defineProperty({}, bookingUUID, BookingStep.Payment));
                } else {
                  BookingModule.setBookingStep(_defineProperty({}, bookingUUID, BookingStep.Order));
                } // Now lets set the customer if we have any


                customer = pulledBooking === null || pulledBooking === void 0 ? void 0 : pulledBooking.CustomerRead;

                if (!(convertedBooking.customerId && customer)) {
                  _context3.next = 40;
                  break;
                }

                country = customer.country, email = customer.email, phone = customer.phone, _id = customer.id, company = customer.company, address = customer.address, allergies = customer.allergies, language = customer.language, firstName = customer.firstName, lastName = customer.lastName, title = customer.title, zipCode = customer.zipCode, emailMarketingOrganiser = customer.emailMarketingOrganiser, birthDate = customer.birthDate, city = customer.city; // Lets show the customer of this booking in the UI

                _context3.next = 40;
                return CustomersModule.setSelectedCustomers([{
                  fullName: firstName + " " + lastName,
                  bookingUuid: bookingUUID,
                  checkOrder: true,
                  country: (country === null || country === void 0 ? void 0 : country.name) || "",
                  email: email,
                  phone: phone,
                  id: _id,
                  company: company,
                  address: address,
                  allergies: allergies,
                  language: language,
                  firstName: firstName,
                  lastName: lastName,
                  title: title,
                  zipCode: zipCode,
                  emailMarketingOrganiser: emailMarketingOrganiser,
                  birthDate: birthDate,
                  city: city
                }]);

              case 40:
                // For each pss lets add its extension
                pssExtensionsCopy = cloneDeep(PSSModule.pssExtensions);
                _iterator = _createForOfIteratorHelper(convertedBooking.pssList);
                _context3.prev = 42;

                _iterator.s();

              case 44:
                if ((_step = _iterator.n()).done) {
                  _context3.next = 59;
                  break;
                }

                pss = _step.value;

                if (!(pss.type !== PCTypes.Donation)) {
                  _context3.next = 56;
                  break;
                }

                _context3.next = 49;
                return getProductCategoryById(pss.categoryId);

              case 49:
                pc = _context3.sent;

                if (pc) {
                  _context3.next = 53;
                  break;
                }

                LogService.info("Error PC not found in local DB after pulling the booking, pssId: ".concat(pss.id, " from backend"), undefined, LogLevel.Error);
                return _context3.abrupt("continue", 57);

              case 53:
                pssExtensionsCopy = cloneDeep(addPSSExtensions({
                  pssExtensions: pssExtensionsCopy,
                  dt: [{
                    psc: pc,
                    pss: pss
                  }]
                }));
                _context3.next = 57;
                break;

              case 56:
                // We are in a donation pss case
                // we know we don't have its PC in localDB
                pssExtensionsCopy = cloneDeep(addPSSExtensions({
                  pssExtensions: pssExtensionsCopy,
                  dt: [{
                    psc: null,
                    pss: pss
                  }]
                }));

              case 57:
                _context3.next = 44;
                break;

              case 59:
                _context3.next = 64;
                break;

              case 61:
                _context3.prev = 61;
                _context3.t0 = _context3["catch"](42);

                _iterator.e(_context3.t0);

              case 64:
                _context3.prev = 64;

                _iterator.f();

                return _context3.finish(64);

              case 67:
                PSSModule.setPSSExtensions(pssExtensionsCopy);
                BookingModule.selectBooking(bookingUUID);
                _context3.next = 78;
                break;

              case 71:
                _context3.prev = 71;
                _context3.t1 = _context3["catch"](4);
                errorDetails = handleErrorAndPrepareMessage(_context3.t1);
                console.log("errorDetails");
                console.log(errorDetails);
                LogService.info("".concat(errorDetails.errorType, " Error when pulling booking with id: ").concat(selectedOrderId, " from backend"), {
                  params: {
                    err: _context3.t1,
                    errorDetails: errorDetails
                  }
                }, LogLevel.Error);
                NotificationService.showCustomMessage(errorDetails.errorMessage, "error"); // console.log(err);
                // console.log(Object.keys(err));
                // console.log(err.message);
                // console.log(err.graphQLErrors);
                // console.log(err.networkError);
                // console.log(err.extraInfo);

              case 78:
                ModalModule.setStatus(ModalStatus.Hidden);
                AppModule.updatedIsLoading(false);

              case 80:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[4, 71], [42, 61, 64, 67]]);
      }))();
    },
    getPSCNotIncludedInConfig: function getPSCNotIncludedInConfig(pulledBooking) {
      var categoryIds = [];

      if (!POSConfigModule.getSelectedConfig) {
        throw new Error(POSConfigErrors.NoPOSConfigSelected);
      }

      var selectedConfigTicketGroups = POSConfigModule.getSelectedConfig.ticketGroups;
      var pssList = pulledBooking.pssList;

      var _loop = function _loop(i) {
        var psc = pssList[i].ProductSlotCategoryRead;
        var pscTicketGroups = psc.TicketGroupTicketList.map(function (tg) {
          return tg.TicketGroupId;
        }); // If at least one tgId of the PSC is not included in selectedConfigTicketGroups then we add psc.Id to categoryIds

        var _loop2 = function _loop2(j) {
          var index = selectedConfigTicketGroups.findIndex(function (it) {
            return it === pscTicketGroups[j];
          });

          if (index < 0) {
            // This psc ticketGroupId is not included in the currently selected config, lets add this categoryId to categoryIds array
            var pscId = pssList[i].ProductSlotCategoryRead.Id;
            categoryIds.push(pscId);
            return "break";
          }
        };

        for (var j = 0; j < pscTicketGroups.length; j++) {
          var _ret = _loop2(j);

          if (_ret === "break") break;
        }
      };

      for (var i = 0; i < pssList.length; i++) {
        _loop(i);
      }

      return categoryIds;
    }
  }
});